import React, { Fragment, useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";

import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";

const SearchBar = ({
  selected,
  placeholder,
  handleUpdateQuickTaleStatus,
  handleUpdateQuickTaleApprovalStatus,
  handleDeleteQuickTale,
  handleSearch,
  handleGetLink,
  handleSendLink,
  handleBulkArea,
  handleBulkAutoApprove,
}) => {
  const [areaOptions, setAreaOptions] = useState(false);
  const [statusOptions, setStatusOptions] = useState(false);
  const [whoCanListenOptions, setWhoCanListenOptions] = useState(false);
  const [linkOptions, setLinkOptions] = useState(false);
  const [autoApproveOptions, setAutoApproveOptions] = useState(false);

  const anyActive = linkOptions || statusOptions || autoApproveOptions || whoCanListenOptions;

  useEffect(() => {
    if (selected && selected.length < 1) {
      setStatusOptions(false);
      setWhoCanListenOptions(false);
      setLinkOptions(false);
      setAreaOptions(false);
      setAutoApproveOptions(false);
    }
  }, [selected]);

  const fadeStyle = (isActive) => ({
    opacity: anyActive && !isActive ? 0.3 : 1,
    transition: "opacity 0.2s ease",
  });

  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder ? placeholder : "Search name, phone, email"}
        // value={""}
        onChange={
          handleSearch ? (e) => handleSearch(e) : () => console.log("search")
        }
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />
      {selected && selected.length > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selected.length} selected</span>
          <TrendingFlatIcon fontSize="large" style={{ color: "#242424" }} />
          <span
            style={{
              ...statusTextSTyles,
              color: linkOptions ? "#9447AF" : "#00A7CD",
              ...fadeStyle(linkOptions),
            }}
            onClick={() => {
              setLinkOptions((prev) => !prev);
              setStatusOptions(false);
              setWhoCanListenOptions(false);
              setAreaOptions(false);
              setAutoApproveOptions(false);
            }}
          >
            Contributor Request
          </span>
          {linkOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span style={statusTextSTyles} onClick={handleSendLink}>
                Send Email
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span style={statusTextSTyles} onClick={handleGetLink}>
                Get Link
              </span>
            </Fragment>
          )}
          {handleBulkArea && (
            <>
              <Divider
                orientation="vertical"
                style={{ height: 25, borderColor: "#000", ...fadeStyle(false) }}
              />
              <span
                style={{ ...statusTextSTyles, ...fadeStyle(false) }}
                onClick={() => {
                  setStatusOptions(false);
                  setWhoCanListenOptions(false);
                  setLinkOptions(false);
                  setAutoApproveOptions(false);
                  handleBulkArea();
                }}
              >
                Area
              </span>
            </>
          )}
          
          <Divider
            orientation="vertical"
            style={{ height: 25, borderColor: "#000", ...fadeStyle(statusOptions) }}
          />
          <span
            style={{
              ...statusTextSTyles,
              color: statusOptions ? "#9447AF" : "#00A7CD",
              ...fadeStyle(statusOptions),
            }}
            onClick={() => {
              setStatusOptions((prev) => !prev);
              setAreaOptions(false);
              setWhoCanListenOptions(false);
              setLinkOptions(false);
              setAutoApproveOptions(false);
            }}
          >
            Status
          </span>
          {statusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleStatus("approved")}
              >
                Approved
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleStatus("pending")}
              >
                Pending
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleStatus("denied")}
              >
                Denied
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleStatus("removed")}
              >
                Removed
              </span>
            </Fragment>
          )}
          {handleBulkAutoApprove && (
            <>
              <Divider
                orientation="vertical"
                style={{ height: 25, borderColor: "#000", ...fadeStyle(autoApproveOptions) }}
              />
              <span
                style={{
                  ...statusTextSTyles,
                  color: autoApproveOptions ? "#9447AF" : "#00A7CD",
                  ...fadeStyle(autoApproveOptions),
                }}
                onClick={() => {
                  setAutoApproveOptions((prev) => !prev);
                  setAreaOptions(false);
                  setStatusOptions(false);
                  setWhoCanListenOptions(false);
                  setLinkOptions(false);
                }}
              >
                Auto Approve
              </span>
              {autoApproveOptions && (
                <Fragment>
                  <TrendingFlatIcon
                    fontSize="medium"
                    style={{ color: "#919191" }}
                  />
                  <span
                    style={statusTextSTyles}
                    onClick={() => handleBulkAutoApprove(true)}
                  >
                    On
                  </span>
                  <Divider
                    orientation="vertical"
                    style={{ height: 15, borderColor: "#919191" }}
                  />
                  <span
                    style={statusTextSTyles}
                    onClick={() => handleBulkAutoApprove(false)}
                  >
                    Off
                  </span>
                </Fragment>
              )}
            </>
          )}
          <Divider
            orientation="vertical"
            style={{ height: 25, borderColor: "#000", ...fadeStyle(whoCanListenOptions) }}
          />
          <span
            style={{
              ...statusTextSTyles,
              color: whoCanListenOptions ? "#9447AF" : "#00A7CD",
              ...fadeStyle(whoCanListenOptions),
            }}
            onClick={() => {
              setWhoCanListenOptions((prev) => !prev);
              setStatusOptions(false);
              setAreaOptions(false);
              setLinkOptions(false);
              setAutoApproveOptions(false);
            }}
          >
            Who Can Listen
          </span>

          {whoCanListenOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("public")}
              >
                Public
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("private")}
              >
                Private
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("unlisted")}
              >
                Unlisted
              </span>
              {/* <Divider orientation="vertical" style={{ height: 15, borderColor: "#919191" }} />
              <span
                style={statusTextSTyles}
                onClick={() => handleUpdateQuickTaleApprovalStatus("draft")}
              >
                Draft
              </span> */}
            </Fragment>
          )}
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const statusTextSTyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};
